module.exports = __webpack_public_path__ + "static/media/colorZentangle.94704519.JPG";